<template>
  <div class="service_page">
    <div class="service_item"
         v-for="(item,index) in list"
         :key="index">
      <div class="logo">
        <img :src="$imgUrl+item.img"
             alt="">
      </div>
      <div class="font24"
           style="margin-bottom:20px">{{item.title}}</div>
      <div class="item mainColor"
           v-for="(x,y) in item.list"
           :key="y+'y'">
        {{x.title}}
        <br>
        <span v-if="x.content"
              class="font12"
              style="font-weight:400;">{{x.content}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [
        { title: '经营咨询', img: 'home/FL_JY.png', list: [{ title: '营采鲜顾问' }, { title: '样板门店打造' }, { title: '配送体系搭建' }] },
        { title: '管理咨询', img: 'home/FL_GL.png', list: [{ title: '人力资源体系', content: '选、用、育、留' }, { title: '管理能力提升', content: '领导力、管理力、执行力' }] },
        { title: '财税咨询', img: 'home/FL_CW.png', list: [{ title: '财务体系' }, { title: '税务体系' }, { title: '法务体系' }] },
        { title: '战略咨询', img: 'home/FL_ZL.png', list: [{ title: '企业战略顾问', content: '干啥事、谁来干、钱咋分' }, { title: '总部体系搭建', content: '营、采、鲜、配' }] }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.service_page {
  width: 100%;
  display: flex;
  padding-top: 100px;
  box-sizing: border-box;
  .service_item:hover {
    bottom: 20px;
  }
  .service_item {
    transition: all 4s ease-in-out;
    flex: 1;
    border-radius: 10px;
    text-align: center;
    margin-right: 20px;
    position: relative;
    padding: 20px 20px 14px 20px;
    background-color: #fff;
    // height: 289px;
    color: #000;
    padding-top: 80px;
    .item {
      padding: 10px 0;
      text-align: center;
      background: rgba(255, 219, 220, 0.5);
      font-weight: bold;
      margin-bottom: 10px;
    }
    .logo {
      position: absolute;
      top: -60px;
      height: 120px;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
      }
    }
  }
  .service_item:nth-child(4) {
    margin-right: 0;
  }
}
</style>